export interface ToolbarShortcutRegistryItem {
  id: string;
  labelKey: string;
  targetPath: string;
}

export const TOOLBAR_SHORTCUT_REGISTRY: ToolbarShortcutRegistryItem[] = [
  { id: "new-job", labelKey: "New job", targetPath: "/service/jobs" },
  { id: "add-new-client", labelKey: "Add new client", targetPath: "/clients" },
  { id: "add-new-contract", labelKey: "Add new contract", targetPath: "/contracts" },
  { id: "add-new-equipment", labelKey: "Add new equipment", targetPath: "/equipment-section/equipments" },
  { id: "add-new-counter", labelKey: "Add new counter", targetPath: "/equipment-section/equipments" },
  { id: "add-producer", labelKey: "Add producer", targetPath: "/equipment-section/producers" },
  { id: "add-configuration", labelKey: "Add configuration", targetPath: "/equipment-section/configurations" },
  { id: "add-new-issue", labelKey: "Add new issue", targetPath: "/service/issues-catalog" },
  { id: "add-new-service", labelKey: "Add new service", targetPath: "/service/services-catalog" },
  { id: "add-external-service", labelKey: "Add external service", targetPath: "/service/external-services" },
  { id: "add-new-group", labelKey: "Add new group", targetPath: "/service/statistics/equipment-groups" },
  { id: "add-part", labelKey: "Add part", targetPath: "/service/stock-status" },
  { id: "add-ordered-part", labelKey: "Add ordered part", targetPath: "/service/stock-status" },
  { id: "add-used-part", labelKey: "Add used part", targetPath: "/service/stock-status" },
  { id: "new-invoice", labelKey: "New invoice", targetPath: "/invoices" },
];

export const TOOLBAR_SHORTCUT_PENDING_KEY = "__toolbar_shortcut_pending_v1";

export const getToolbarShortcutById = (id: string) =>
  TOOLBAR_SHORTCUT_REGISTRY.find((item) => item.id === id);
